"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHelmet = require("react-helmet");

var _utils = require("../../../utils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function prepareFontFaces(fontIds, assetsMap) {
  return fontIds.map(function (assetId) {
    var asset = assetsMap.get(assetId);
    if (!asset) return '';
    var ORIGINAL = asset.assetFiles.ORIGINAL;
    return "@font-face {\n        font-family: '".concat((0, _utils.getFontFamily)(assetId), "';\n        src: url(").concat(ORIGINAL && ORIGINAL.sourceUrl, ");\n      }");
  }).filter(Boolean).join('');
}

function FontsStyleHelmet(_ref) {
  var fontIds = _ref.fontIds,
      assetsMap = _ref.assetsMap;

  if (fontIds && fontIds.length !== 0) {
    return /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("style", {
      type: "text/css"
    }, "".concat(prepareFontFaces(fontIds, assetsMap))));
  }

  return null;
}

var _default = (0, _react.memo)(FontsStyleHelmet);

exports.default = _default;